import Table from '../reusable_components/Table.js';
import { url } from '../utils/config.js';
import { title } from '../utils/style.js';
function FinanceFleetAppointments() {

    const options = [
        {
            header: 'Booking Id',
            key: "id",
            width: "10%",
            render: (data => { return `FAP000${data.id}` })
        },
        {
            header: 'Problem Description',
            key: 'problemDescription',
            width: "15%"
        },
        {
            header: 'Status',
            key: "status",
            render: (data => { return data.status === 'Assigned' ? 'Open' : data.status }),
            width: "10%"
        },
        {
            header: 'DATE',
            key: 'date',
            placeHolder: 'mm-dd-yyyy',
            width: "10%"
        },
        {
            header: 'TIME',
            key: 'time',
            width: "15%"
        },
    ]

    const excludeFilter = ['VEHICLE INFO']

    return (
        <div className="p-4">
            <div className={`${title} mb-4`}>Fleet Appointments</div>
            <Table
                url={url + '/fleet_appointments'}
                options={options}
                pagination
                noButton
                excludeFilter={excludeFilter}
            />
        </div>
    )
}

export default FinanceFleetAppointments;